const DEFAULT_NONTRANSFORMABLE_URLS = [
  '.svg',
  '.gif',
  'cache.net-a-porter.com/images/products',
  'cache.mrporter.com/variants/images',
  'iris-integ.dev.product.ext.net-a-porter.com/mrp'
]

const DEFAULT_WZERO_FORMAT = ['.gif']

const NON_FORCE_JPG_FORMAT = ['.gif', '.svg']

export const getImageTypes = (item, types = [], shouldFallback = true) => {
  const response = {}
  const pictures = item.pictures || []
  const fallback = shouldFallback ? pictures[0] : {}
  types.forEach((type, index) => {
    response[type] = pictures[index] || fallback || {}
  })
  return response
}

export const getExtension = (imageUrl) => {
  const extensionRegex = /\.(\w{3,4})(?:$|\?)/i
  const extensionMatch = imageUrl.match(extensionRegex)
  if (NON_FORCE_JPG_FORMAT.includes(extensionMatch[0])) {
    return extensionMatch && extensionMatch[1] && extensionMatch[1].toLowerCase()
  }
  return 'jpg'
}

// src attribute does not support 'w descriptors' which causes the image not to render in IE
// (while working on other browsers though)
export const getOptimisedUrl = (imageUrl = '', quality, width = 400, hasDescriptor, withWZero) => {
  // ImageSphere domains => cache.mrporter.com, cache.net-a-porter.com or has 'imagesphere' in url
  // Temporary solution while CoreMedia doesn't switch to ImageSphere urls
  const imageSphereDomains = [
    'cache.mrporter.com',
    'cache.net-a-porter.com',
    'imagesphere',
    'www.theoutnet.com/cms',
    'preprod.theoutnet.com/cms',
    'www.net-a-porter.com/content/'
  ]
  let url

  if (imageSphereDomains.some((domain) => imageUrl.indexOf(domain) > -1)) {
    if (withWZero) {
      url = `${imageUrl}/w0.${getExtension(imageUrl)}`
    } else {
      url = `${imageUrl}/w${width}_q${quality}.${getExtension(imageUrl)}`
    }
  } else {
    const noQueryParams = ['www.net-a-porter.com/variants/', 'data:image']
    // Defaults to Akamai Image Manager
    // wZero rule just applys to ImageSphere domains
    if (withWZero || noQueryParams.some((domain) => imageUrl.indexOf(domain) > -1)) {
      return imageUrl
    }
    url = `${imageUrl}?imwidth=${width}&improfile=isc`
  }

  return hasDescriptor ? `${url} ${width}w` : url
}

export const getSrcAttrs = (
  imageUrl = '',
  quality,
  { widths = [1000, 1500], defaultWidth = 800 } = {},
  nonTransformableUrls = DEFAULT_NONTRANSFORMABLE_URLS,
  wZero
) => {
  const isNonTransformableUrl = Boolean(nonTransformableUrls.find((nonTransformableUrl) => imageUrl.indexOf(nonTransformableUrl) > -1))
  const isWZero = wZero || (Boolean(DEFAULT_WZERO_FORMAT.find((format) => imageUrl.indexOf(format) > -1)) && imageUrl.indexOf('imagesphere.dev') === -1)

  if (isWZero && isNonTransformableUrl) {
    const wZeroImageURL = getOptimisedUrl(imageUrl, quality, defaultWidth, false, true)

    return {
      src: wZeroImageURL,
      srcSet: [wZeroImageURL]
    }
  }

  return {
    src: isNonTransformableUrl ? imageUrl : getOptimisedUrl(imageUrl, quality, defaultWidth, false, false),
    srcSet: isNonTransformableUrl ? [imageUrl] : widths.map((width) => getOptimisedUrl(imageUrl, quality, width, true, false)).join(', ')
  }
}

export const getWidth = (b, spanWidth, maxImageWidth) => {
  const combinedGutters = b.gutterWidth * (b.columnCount - 1)
  const columnWidth = ((maxImageWidth || b.width) - combinedGutters) / b.columnCount
  // width of columns and gutters
  return columnWidth * spanWidth + b.gutterWidth * (spanWidth - 1)
}

export const getSizes = (breakpoints, gridContext, breakpointsSizes, mediaQuery) => {
  if (!gridContext) return '100vw'
  const minSizes = mediaQuery.min(breakpointsSizes)
  const maxSizes = mediaQuery.max(breakpointsSizes)

  return breakpoints
    .map((breakpointName) => {
      const minImageWidth = mediaQuery.minPx[breakpointName]
      const maxImageWidth = mediaQuery.maxPx[breakpointName]
      const breakpointSize = breakpointsSizes[breakpointName]
      const spanWidth = gridContext[breakpointName]
      const minWidth = minSizes[breakpointName]
      const maxWidth = maxSizes[breakpointName]
      const mq = []
      if (minWidth) mq.push(minWidth)
      if (minWidth && maxWidth) mq.push('and')
      if (maxWidth) mq.push(maxWidth)

      return `${mq.join(' ')} ${getWidth(breakpointSize, spanWidth, maxImageWidth || minImageWidth)}px`
    })
    .join(', ')
}
